import styled from 'styled-components';
import { body2, spacing } from 'ui/theme';

export const Cell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  overflow-y: visible;
  padding: ${spacing.threeQuarter};
  margin: 0;
`;
